import { filter, map, retry, switchMap } from "rxjs/operators";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionAuth } from "../../auth/actionAuth";
import { TypeActionCheats } from "../../cheats/actionCheats";
import { actionShopCatalogReceived, TypeActionShop } from "../actionShop";
/**
 * This epic listens for <code>TypeActionAuth.Login</code> and not <code>TypeActionShop.RequestUpdate</code>,
 * because we don't want it to re-request the catalog data during same session, when offers expire.
 * @param action$
 * @param state$
 * @param deps
 */
export var epicShopUpdateCatalog = function (action$, state$, deps) {
    return action$.pipe(
    // unfortunately we have to update the catalog at every shift level due to how sms offers
    // behave.
    filter(function (action) {
        return action.type === TypeActionAuth.Login ||
            action.type === TypeActionCheats.ClientIp ||
            (action.type === TypeActionShop.UpdateShiftLevel &&
                state$.value.playerInfo.playerId !== undefined);
    }), switchMap(function (action) {
        var state = state$.value;
        var language = state.loca.lang;
        var playerId = action.playerId ? action.playerId : selectOwnPlayerId(state);
        return deps.netSend({
            id: CommandCode.WebShopCatalog,
            props: {
                language: language,
                playerId: playerId,
            },
        });
    }), retry(), map(function (res) { return actionShopCatalogReceived(res); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/epics/epicShopUpdateCatalog.ts
// module id = 2342
// module chunks = 3